<template>
    <div>
        <el-dialog v-model="examinationPaperDownloadShow" title="Tips" width="500" :show-close="false"
            :align-center="true" :close-on-click-modal="false">
            <template #header>
                <div class="header">试卷下载</div>
                <div class="close_icon" @click="closePopup">
                    <el-icon :size="20">
                        <CloseBold />
                    </el-icon>
                </div>
            </template>
            <div class="dialog_content flex FlexBetween">
                <div class="content_left">
                    <paperDownloadConig ref="paperDownloadConig" :examinationInfo="examinationInfo"
                        :paperInfo="paperInfo" @downloadAsPDF="downloadAsPDF" @config-change="handleConfigChange"
                        @downloadAsCardPDF="downloadAsCardPDF" @downloadPaperWithAudio="downloadPaperWithAudio"
                        @order-paid="handleOrderPaid">
                    </paperDownloadConig>
                </div>
                <div class="splid_line"></div>
                <div class="content_left">
                    <paperDownloadPreview ref="paperDownloadPreview" :paper-config="paperConfig" :paperInfo="paperInfo">
                    </paperDownloadPreview>
                </div>
            </div>
            <!-- 隐藏的答题卡生成组件 -->
            <answer-card-download ref="answerCardRef" :paper-config="paperConfig" :paper-content="paperContent"
                :paper-title="paperTitle" v-if="showAnswerCard">
            </answer-card-download>
        </el-dialog>
    </div>
</template>

<script>
import paperDownloadConig from '../examinationPaper/paperDownloadConig.vue';
import paperDownloadPreview from '../examinationPaper/paperDownloadPreview.vue';
import answerCardDownload from '../examinationPaper/answerCardDownload.vue'; // 导入新组件
export default {
    name: "GjkcH5ExaminationPaperDownload",
    components: {
        paperDownloadConig,
        paperDownloadPreview,
        answerCardDownload
    },

    props: {
        examinationInfo: {},
        paperInfo: {}
    },

    data() {
        return {
            examinationPaperDownloadShow: false,
            paperConfig: {
                paperSize: 'A4',
                paperStyleSelectList: [],
                answerShow: false,
                answerPosition: 1,
                additionalSelectList: [],
                audioDownload: 1,
                payType: 1,
                couponSelected: ''
            },
            paperContent: {}, // 需要传入试卷内容
            paperTitle: '江苏省南京市高淳区2023-2024学年七年级下学期6月期未英语模拟试题',
            showAnswerCard: false, // 控制答题卡是否渲染
        };
    },
    computed: {
        hasPaperContent() {
            return Object.keys(this.paperContent).length > 0;
        }
    },

    watch: {
        'paperDownloadPreview?.paperContent': {
            handler(newVal) {
                if (newVal && Object.keys(newVal).length > 0) {
                    this.paperContent = newVal;
                }
            },
            deep: true,
            immediate: true
        }
    },

    async mounted() {
        // 等待下一个 tick，确保子组件已渲染
        await this.$nextTick();
        await this.getPaperContent();
    },

    methods: {
        closePopup() {
            this.examinationPaperDownloadShow = false;
        },
        downloadAsPDF() {
            this.$refs.paperDownloadPreview.downloadAsPDF();
        },
        handleConfigChange(config) {
            // 接收从配置组件传过来的配置
            this.paperConfig = config;
        },
        // 处理订单支付成功，转发给父组件
        handleOrderPaid(data) {
            this.$emit('order-paid', data);
        },
        async getPaperContent() {
            // 方式1：从预览组件获取
            if (this.$refs.paperDownloadPreview) {
                // 如果预览组件有异步加载，需要等待
                await this.$refs.paperDownloadPreview.loadContent?.();
                this.paperContent = this.$refs.paperDownloadPreview.paperContent || {};
            }

            // 如果没有内容，从API获取
            if (Object.keys(this.paperContent).length === 0) {
                try {
                    // const res = await this.fetchPaperContent(); // 实现API调用
                    // this.paperContent = res.data;
                    if (this.$refs.paperDownloadPreview?.paperContent) {
                        this.paperContent = this.$refs.paperDownloadPreview.paperContent;
                    }
                } catch (error) {
                    console.error('获取试卷内容失败:', error);
                }
            }
        },

        async downloadAsCardPDF() {
            try {
                // 确保有数据
                if (Object.keys(this.paperContent).length === 0) {
                    await this.getPaperContent();
                }

                // 显示答题卡组件（触发渲染）
                this.showAnswerCard = true;

                // 等待DOM更新和组件渲染
                await this.$nextTick();
                await this.$nextTick(); // 有时需要两次nextTick确保子组件渲染完成

                try {
                    // 调用下载方法
                    await this.$refs.answerCardRef.downloadAnswerCard();

                    // 下载完成后隐藏答题卡（可选）
                    // this.showAnswerCard = false;

                    this.$message.success('答题卡下载成功');
                    // 隐藏答题卡组件（触发渲染）
                    this.showAnswerCard = false;
                } catch {
                    // 隐藏答题卡组件（触发渲染）
                    this.showAnswerCard = false;
                }
            } catch (error) {
                console.error('答题卡下载失败:', error);
                this.$message.error('答题卡下载失败');
            }
        },
        async downloadPaperWithAudio() {
            try {
                // 确保有数据
                if (Object.keys(this.paperContent).length === 0) {
                    await this.getPaperContent();
                }

                // 调用预览组件的方法
                await this.$refs.paperDownloadPreview.downloadPaperWithAudio();
            } catch (error) {
                console.error('下载失败:', error);
                this.$message.error('下载失败');
            }
        }
    },
};
</script>
<style lang="scss" scoped>
:deep(.el-dialog) {
    box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.06);
    border-radius: 10px;
    padding: 0;
    width: 1200px;
    min-height: 480px;
    position: relative;
}

:deep(.el-dialog__header) {
    position: relative;
    padding: 0 20px;
    box-sizing: border-box;
    text-align: start;
}

.header {
    //   text-align: center;
    //   font-weight: bold;
    font-size: 20px;
    color: #333333;
    line-height: 60px;
}

.close_icon {
    position: absolute;
    top: 20px;
    right: 20px;
    color: #333333;
}

:deep(.el-table th.el-table__cell) {
    background-color: #F5F7FA;
    /* 自定义颜色 */
}

.dialog_content {
    padding: 0 20px;

    .content_left {
        width: 48%;
        max-height: 800px;
    }

    .splid_line {
        border-right: 1px dashed #EBECED;
    }
}

.pay-success-tip {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 126px;
    height: 126px;
    background: #f0f9f0;
    border-radius: 8px;
    color: #00C758;
    font-size: 14px;

    .success-icon {
        width: 40px;
        height: 40px;
        margin-bottom: 8px;
    }
}
</style>
